<template>
  <Layout1 id="salesKPI">
    <template slot="slot_title">
      <MSelect :defaultValue="range" @input="range=$event"></MSelect>
      <Search :defaultValue="searchText" @input="searchText=$event"/>
      <Btn @click="exportTable" :icon="'excel1'" :bg="'var(--color-checked)'" :text="'匯出'"/>
      <div>預約總金額<br>{{sumBooking}} 元</div>
      <div>總營收<br>{{sumAll}} 元</div>
      <div class="boxToggle" :style="{marginLeft: 'auto'}" :hidden="open"   @click="open=true">
        <div><div class="toggle" :style="{transform: 'rotate(180deg)'}"></div>數值設定</div>
      </div>
    </template>
    <div class="boxabs" :hidden="!open">
      <div @click="open=false"><div class="toggle"></div>數值設定</div>
      <div class="inputs" v-if="sourcemap">
        <div class="ratio" v-for="val in Object.keys(sourcemap)" :label="val" :key="val">
          <div>{{val}}</div>
          <div>{{sourcemap[val]}}</div>
        </div>
        <!-- <div class="money" label="總獎金"><input type="text" id="bonus"></div>
        <div class="persentage" label="外場分配率"><input type="text" id="pfront"></div>
        <div class="persentage" label="內場分配率"><input type="text" id="pback"></div>
        <div class="x" label="加成倍數"><input type="text" :value="cross" id="cross"></div> -->
      </div>
      <!-- <div class="btns">
        <button class="cancelBtn" @click="open=false">取消</button>
        <button class="saveBtn" @click="setValue">套用</button>
      </div> -->
    </div>
    <TableDef :rows="rows">
      <template slot="slot_head">
        <th :style="{textAlign:'start'}">部門</th>
        <th :style="{textAlign:'start'}">員工</th>
        <th>訂單數</th>
        <th>預約人次(大人)</th>
        <th>預約人次(小孩)</th>
        <th>總預約人次</th>
        <th>桌數</th>
        <th>套餐數</th>
        <th>合計金額</th>
        <th>加權金額</th>
        <th>加權後佔比</th>
        <th>總餐廳業績</th>
      </template>
      <tr slot-scope="{item:{t, salesman,sheets, tables, sets, reserveNum, reserveNumChild, reserveAll, total, totalRatio}}"
       :style="[t?{background: 'rgba(227, 120, 120, 0.15)'}:{}, {border:'none'}, {height: '64px'}]">
        <td :style="[{textAlign:'start'}, t?{fontSize: '24px', fontWeight: '700'}:{}]" :colspan="t&&t==='sum'?2:1">{{salesman?.department || ''}}</td>
        <td :style="{textAlign:'start'}" v-if="!t">{{salesman?.name || ''}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{sheets}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{reserveNum}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{reserveNumChild}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{reserveAll}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{tables.toFixed(1)}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{sets}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{Math.floor(total)}}</td>
        <td :style="[{background: 'rgba(227, 120, 120, 0.15)'}, t?{fontSize: '24px', fontWeight: '700'}:{}]">{{Math.floor(totalRatio)}}</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{totalRatio*100/sumBooking ? (totalRatio*100/sumBooking).toFixed(2) : 0}}%</td>
        <td :style="[t?{fontSize: '24px', fontWeight: '700'}:{}]">{{(totalRatio*100/sumAll).toFixed(2)}}%</td>
      </tr>
    </TableDef>
  </Layout1>
</template>

<script>
import XLSX from 'xlsx'
import MSelect from '../../components/dateRadio/MonthSelectKPI.vue'
import Btn from '../../components/btn/round.vue'
import Layout1 from '../../components/layout/L1.vue'
import TableDef from '../../components/tables/t2.vue'
import Search from '../../components/input/search.vue'
import { getapi } from '../../store/fetch'
export default {
  components: { MSelect, Btn, Search, Layout1, TableDef },
  data () {
    const start = this.moment().startOf('month').format('yyyy-MM-DD')
    const end = this.moment().endOf('month').format('yyyy-MM-DD')
    const duration = this.moment(end).diff(this.moment(start), 'day')
    return {
      open: false,
      range: { start, end, duration },
      sumBooking: 0,
      sumAll: 0,
      each: [],
      searchText: null,
      sourcemap: null
    }
  },
  watch: {
    range: {
      deep: true,
      immediate: true,
      async handler () {
        await this.getdata()
      }
    }
  },
  computed: {
    store () {
      return this.$route.query.store
    },
    mainsales () {
      return (this.each || []).filter(e => e.salesman.department === '業務部')
    },
    othersales () {
      return (this.each || []).filter(e => e.salesman.department !== '業務部')
    },
    mainSum () {
      const mainsales = this.mainsales
      return {
        t: 'sum',
        salesman: { department: '業務部合計' },
        sheets: this.reduce(mainsales.map(e => e.sheets)),
        tables: this.reduce(mainsales.map(e => e.tables)),
        sets: this.reduce(mainsales.map(e => e.sets)),
        reserveNum: this.reduce(mainsales.map(e => e.reserveNum)),
        reserveNumChild: this.reduce(mainsales.map(e => e.reserveNumChild)),
        reserveAll: this.reduce(mainsales.map(e => e.reserveAll)),
        total: this.reduce(mainsales.map(e => e.total)),
        totalRatio: this.reduce(mainsales.map(e => e.totalRatio))
      }
    },
    otherSum () {
      const othersales = this.othersales
      return {
        t: 'sum',
        salesman: { department: '其它部分合計' },
        sheets: this.reduce(othersales.map(e => e.sheets)),
        tables: this.reduce(othersales.map(e => e.tables)),
        sets: this.reduce(othersales.map(e => e.sets)),
        reserveNum: this.reduce(othersales.map(e => e.reserveNum)),
        reserveNumChild: this.reduce(othersales.map(e => e.reserveNumChild)),
        reserveAll: this.reduce(othersales.map(e => e.reserveAll)),
        total: this.reduce(othersales.map(e => e.total)),
        totalRatio: this.reduce(othersales.map(e => e.totalRatio))
      }
    },
    rows () {
      const mainsales = this.searchText ? this.mainsales.filter(e => new RegExp(this.searchText).test(e.salesman.name)) : this.mainsales
      const othersales = this.searchText ? this.othersales.filter(e => new RegExp(this.searchText).test(e.salesman.name)) : this.othersales
      return [...mainsales, this.mainSum, ...othersales, this.otherSum]
    },
    dtrg () {
      if (!this.range.duration) {
        return this.range.start
      } else {
        return this.range.start + '_' + this.range.end
      }
    }

  },
  methods: {
    exportTable () {
      const mainsales = this.mainsales
      const json = [...JSON.parse(JSON.stringify(this.mainsales)).map(e => {
        return {
          員工: e.salesman.name,
          訂單數: e.sheets,
          '預約人次(大人)': e.reserveNum,
          '預約人次(小孩)': e.reserveNumChild,
          總預約人次: e.reserveAll,
          桌數: e.tables,
          套餐數: e.sets,
          合計金額: e.total,
          加權金額: e.totalRatio,
          加權後佔比: `${(e.totalRatio * 100 / this.sumBooking).toFixed(2)}%`,
          總餐廳業績: `${(e.totalRatio * 100 / this.sumAll).toFixed(2)}%`
        }
      }), {
        員工: '業務部合計',
        訂單數: this.reduce(mainsales.map(e => e.sheets)),
        '預約人次(大人)': this.reduce(mainsales.map(e => e.reserveNum)),
        '預約人次(小孩)': this.reduce(mainsales.map(e => e.reserveNumChild)),
        總預約人次: this.reduce(mainsales.map(e => e.reserveAll)),
        桌數: this.reduce(mainsales.map(e => e.tables)),
        套餐數: this.reduce(mainsales.map(e => e.sets)),
        合計金額: this.reduce(mainsales.map(e => e.total)),
        加權金額: this.reduce(mainsales.map(e => e.totalRatio)),
        加權後佔比: `${(this.reduce(mainsales.map(e => e.totalRatio)) * 100 / this.sumBooking).toFixed(2)}%`,
        總餐廳業績: `${(this.reduce(mainsales.map(e => e.totalRatio)) * 100 / this.sumAll).toFixed(2)}%`
      }]
      const othersales = this.othersales
      const json1 = [...JSON.parse(JSON.stringify(this.othersales)).map(e => {
        return {
          員工: e.salesman.name,
          訂單數: e.sheets,
          '預約人次(大人)': e.reserveNum,
          '預約人次(小孩)': e.reserveNumChild,
          總預約人次: e.reserveAll,
          桌數: e.tables,
          套餐數: e.sets,
          合計金額: e.total,
          加權金額: e.totalRatio,
          加權後佔比: `${(e.totalRatio * 100 / this.sumBooking).toFixed(2)}%`,
          總餐廳業績: `${(e.totalRatio * 100 / this.sumAll).toFixed(2)}%`
        }
      }), {
        員工: '其他合計',
        訂單數: this.reduce(othersales.map(e => e.sheets)),
        '預約人次(大人)': this.reduce(othersales.map(e => e.reserveNum)),
        '預約人次(小孩)': this.reduce(othersales.map(e => e.reserveNumChild)),
        總預約人次: this.reduce(othersales.map(e => e.reserveAll)),
        桌數: this.reduce(othersales.map(e => e.tables)),
        套餐數: this.reduce(othersales.map(e => e.sets)),
        合計金額: this.reduce(othersales.map(e => e.total)),
        加權金額: this.reduce(othersales.map(e => e.totalRatio)),
        加權後佔比: `${(this.reduce(othersales.map(e => e.totalRatio)) * 100 / this.sumBooking).toFixed(2)}%`,
        總餐廳業績: `${(this.reduce(othersales.map(e => e.totalRatio)) * 100 / this.sumAll).toFixed(2)}%`
      }]
      const worksheet = XLSX.utils.json_to_sheet(json)
      const worksheet1 = XLSX.utils.json_to_sheet(json1)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '業務部')
      XLSX.utils.book_append_sheet(workbook, worksheet1, '其他')
      XLSX.writeFile(workbook, `業務統計_${this.dtrg}.xlsx`)
    },
    async getdata () {
      const start = this.moment(this.range.start).toISOString()
      const duration = this.range.duration
      const { each, all, total, sourcemap } = await getapi('restaurant/sales?' + new URLSearchParams({ store: this.store, start, duration }))
      this.each = each
      this.sumAll = all
      this.sumBooking = total
      this.sourcemap = sourcemap
    }
  }

}
</script>

<style lang="scss">
#salesKPI {
  tr.sum {
    background: rgba(227, 120, 120, 0.15);
    td {
      font-size: 24px;
      font-weight: 900;
    }
  }
}
</style>
<style lang="scss" scoped>
.ratio {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toggle {
  display: inline;
  width: 16px;
  height: 13px;
  background-color: var(--color-pri);
  mask: center / contain no-repeat url(/triangle.svg);
  transform: rotate(0deg);
}
.boxabs {
  position: absolute;
  top: 120px;
  width: 255px;
  height: fit-content;
  right: 32px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  background-color: var(--color-infobox);
  z-index: 200;
  padding: 0 20px 20px 20px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  &>div:nth-child(1) {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

  }
}
.boxToggle {
  width: 285px;
  height: 50px;
  background: var(--color-infobox);
  border-radius: 3px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  margin-right: 32px;
  padding-inline: 20px;
  &>div:nth-child(1) {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }
}
</style>
